import React from 'react';
import styles from './styles.module.scss';

export const Loader = () => (
  <div
    className={styles.loader}
  />
);
